import React from 'react';

import WpButton from 'Wpds/components/button/WpButton';
import WpIcon from 'Wpds/components/icon/WpIcon';
import GoalDetailsPageAiSuggestedSubGoalsOrActionItems from '../GoalDetailsPageAiSuggestedSubGoalsOrActionItems/GoalDetailsPageAiSuggestedSubGoalsOrActionItems';

import './GoalDetailsPageActionItemsEmpty.scss';

type Props = {
  onAddItemClick(): void;
  handleBulkAddItems(bodies: string[]): void;
  goalSlug: string;
};

function GoalDetailsPageActionItemsEmpty({ onAddItemClick, handleBulkAddItems, goalSlug }: Props) {
  return (
    <div className="GoalDetailsPageActionItemsEmpty">
      <div className="GoalDetailsPageActionItemsEmpty__content">
        <span className="mb-3">Add action items to help you work toward this goal.</span>
        <WpButton onClick={onAddItemClick}>
          <WpIcon name="plus-circle" />
          Add Action Item
        </WpButton>
        <GoalDetailsPageAiSuggestedSubGoalsOrActionItems
          goalSlug={goalSlug}
          handleBulkAddItems={handleBulkAddItems}
          suggestedObjectType={'action_item'}
        />
      </div>
    </div>
  );
}

export default GoalDetailsPageActionItemsEmpty;
